export default __webpack_public_path__ + "static/hosting-shape1-4e57998af0a4158a7f50181c708e59eb.png";